import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useUserRole } from "../hooks/useUserRole";

const AdminRoute = () => {
  const { loading } = useAuth();
  const { isAdmin } = useUserRole();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[320px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600" />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/scribe" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
